webpackJsonp([114276838955818,60335399758886],{

/***/ 125:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Return of the Shadow"}}},"layoutContext":{}}

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(273);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(125);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _site = __webpack_require__(412);
	
	var _site2 = _interopRequireDefault(_site);
	
	var _reactBootstrap = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListLink = function ListLink(props) {
	    return _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: props.to },
	            props.children
	        )
	    );
	};
	
	var today = new Date();
	
	exports.default = function (_ref) {
	    var children = _ref.children,
	        data = _ref.data,
	        location = _ref.location;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Navbar,
	            { fixedTop: true, collapseOnSelect: true },
	            _react2.default.createElement(
	                _reactBootstrap.Navbar.Header,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Navbar.Brand,
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: "/" },
	                        "RETURN OF THE SHADOW"
	                    )
	                ),
	                _react2.default.createElement(_reactBootstrap.Navbar.Toggle, null)
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Navbar.Collapse,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Nav,
	                    { pullRight: true },
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { eventKey: 1, onClick: function onClick() {
	                                return (0, _gatsbyLink.navigateTo)('/news');
	                            } },
	                        "NEWS"
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { eventKey: 2, onClick: function onClick() {
	                                return (0, _gatsbyLink.navigateTo)('/connect');
	                            } },
	                        "CONNECT"
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavDropdown,
	                        { eventKey: 3, title: "GAME", id: "basic-nav-dropdown" },
	                        _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { eventKey: 3.1, onClick: function onClick() {
	                                    return (0, _gatsbyLink.navigateTo)('/getting-started');
	                                } },
	                            "GETTING STARTED"
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { eventKey: 3.2, onClick: function onClick() {
	                                    return (0, _gatsbyLink.navigateTo)('/bookofarda');
	                                } },
	                            "BOOK OF ARDA"
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { eventKey: 3.3, onClick: function onClick() {
	                                    return (0, _gatsbyLink.navigateTo)('/races');
	                                } },
	                            "RACES"
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            { eventKey: 3.4, onClick: function onClick() {
	                                    return (0, _gatsbyLink.navigateTo)('/classes');
	                                } },
	                            "CLASSES"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { eventKey: 4, onClick: function onClick() {
	                                return (0, _gatsbyLink.navigateTo)('/logs');
	                            } },
	                        "LOGS"
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { eventKey: 5, onClick: function onClick() {
	                                return (0, _gatsbyLink.navigateTo)('/rcd');
	                            } },
	                        "RCD"
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { eventKey: 6, onClick: function onClick() {
	                                return (0, _gatsbyLink.navigateTo)('/docs');
	                            } },
	                        "DOCS"
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        { eventKey: 7, onClick: function onClick() {
	                                return (0, _gatsbyLink.navigateTo)('/about');
	                            } },
	                        "ABOUT"
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "body-content" },
	            children(),
	            _react2.default.createElement(
	                "div",
	                { className: "footer-container" },
	                _react2.default.createElement(
	                    "footer",
	                    { className: "footer" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "container" },
	                        _react2.default.createElement(
	                            "p",
	                            { className: "" },
	                            "\xA9 ",
	                            today.getFullYear(),
	                            " Return of the Shadow, Inc. ALL RIGHTS RESERVED. All trademarks referenced herein are the properties of their respective owners."
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a340f38903d99fd50089.js